var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"companies-page"},[_c('div',{staticClass:"companies-page_container"},[_c('div',{staticClass:"header"},[_vm._v("\n      简报列表\n    ")]),_c('bulletin-list')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }